import { labelEvents } from "../../../constant/labels";
import { unixTimestampToDate, yearMonthDayFormat, hourMinuteSecondFormat } from "@/utility/dateUtility";

export default {
    eventReadAllBegin(state) {
        state.loading = true;
    },

    eventReadAllSuccess(state, data) {
        state.data = [];
        data.forEach(event => {
            const label = labelEvents.find(label => label.id === event.labelId);
            event.label = label ? label.class : 'primary';
            event.date = [
                unixTimestampToDate(event.startDate, yearMonthDayFormat),
                unixTimestampToDate(event.endDate, yearMonthDayFormat)
            ],
            event.time = [
                unixTimestampToDate(event.startDate, hourMinuteSecondFormat),
                unixTimestampToDate(event.endDate, hourMinuteSecondFormat)
            ]
        });

        state.loading = false;
        state.data = data;
    },

    eventReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    eventAddBegin(state) {
        state.loading = true;
    },

    eventAddSuccess(state) {
        state.loading = false;
    },

    eventAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    eventUpdateBegin(state) {
        state.loading = true;
    },

    eventUpdateSuccess(state) {
        state.loading = false;
    },

    eventUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    eventVisibleBegin(state) {
        state.loading = true;
      },
    
    eventVisibleSuccess(state, data) {
        state.loading = false;
        state.eventVisible = data;
    },
    
    eventVisibleErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    eventDeleteBegin(state) {
        state.loading = true;
    },

    eventDeleteSuccess(state, id) {
        state.loading = false;
        state.data = state.data.filter(event => event.id !== id);
    },

    eventDeleteErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    eventContactsReadAllBegin(state) {
        state.loadingContacts = true;
    },

    eventContactsReadAllSuccess(state, data) {
        state.loadingContacts = false;

        const contactList = data.map(contact => {
            return {
                label: `${contact.firstName} ${contact.lastName}`,
                value: contact.id
            };
        });

        state.contacts = contactList || [];
    },

    eventContactsReadAllErr(state, err) {
        state.loadingContacts = false;
        state.error = err;
    }
};